import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationCancel, Router } from '@angular/router';
import { NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { filter, takeUntil } from 'rxjs/operators';
import { ContractsService } from '../../shared/services/contracts.service';
import { InterviewsService } from '../../shared/services/interviews.service';
import { TitleService } from '../../shared/services/title.service';
import { BeneficiariesService } from '../../shared/services/beneficiaries.service';
import { BeneficiaryBaseComponent } from '../beneficiary-base.component';

@Component({
  selector: 'app-beneficiary-folder',
  templateUrl: './beneficiary-folder.component.html',
  providers: [NgbNav],
  standalone: false,
})
export class BeneficiaryFolderComponent extends BeneficiaryBaseComponent implements OnInit, OnDestroy {
  public activeTabId: string = 'interviews';
  public id: number;

  constructor(
    private readonly titleService: TitleService,
    private readonly beneficiaryService: BeneficiariesService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly contratService: ContractsService,
    private readonly interviewService: InterviewsService,
  ) {
    super();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationCancel),
        takeUntil(this.destroy$),
      )
      .subscribe(() => (this.activeTabId = this.route.firstChild.routeConfig.path));
  }

  public async ngOnInit(): Promise<void> {
    this.id = +this.route.snapshot.paramMap.get('id');

    if (this.id !== 0) {
      this.beneficiary = await this.beneficiaryService.findById(this.id);

      if (this.beneficiary) {
        this.titleService.setTitle('Parcours de ' + this.beneficiary.firstName + ' ' + this.beneficiary.usualName);
      }

      this.contratService.contractUpdated$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateBeneficiaryDetails(this.beneficiary.id);
      });
      this.interviewService.interview$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateBeneficiaryDetails(this.beneficiary.id);
      });
    }
    this.beneficiaryService.beneficiary.setValue(this.beneficiary);
    if (this.route.firstChild.routeConfig.path) {
      this.activeTabId = this.route.firstChild.routeConfig.path;
    }
  }

  public onNavChange(changeEvent: NgbNavChangeEvent): void {
    this.router.navigate([changeEvent.nextId], { relativeTo: this.route });
    this.activeTabId = changeEvent.nextId;
  }

  private async updateBeneficiaryDetails(id: number): Promise<void> {
    this.beneficiary = await this.beneficiaryService.findById(id);
    this.beneficiaryService.beneficiary.setValue(this.beneficiary);
  }
}
